import { render, staticRenderFns } from "./products-inquiry.vue?vue&type=template&id=379cf30e&"
import script from "./products-inquiry.vue?vue&type=script&lang=js&"
export * from "./products-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports